document.addEventListener('DOMContentLoaded', ()=>{
    const form = document.getElementById('message-form');
    form.addEventListener('submit', function(event) {
        event.preventDefault();
        const name = form.querySelector('input[name="name"]').value.trim();
        const email = form.querySelector('input[name="email"]').value.trim();
        const phone = form.querySelector('input[name="phone"]').value.trim();
        const message = form.querySelector('textarea[name="message"]').value.trim();
        if (!name || !email || !phone || !message) {
            alert('Please fill in all required fields!');
            return;
        }
        form.reset();
    // window.scrollTo({ top: 0, behavior: 'smooth' });
    });
});

//# sourceMappingURL=Eco_cosmetics.a10453f7.js.map
